import './less/index.less'
import iciButton from './components/ici-button.vue'

import iciInput from './components/ici-input.vue'
import iciInputGroup from './components/ici-input-group'
import iciMultipleField from './components/ici-multiple-field'
import iciRadioField from './components/ici-radio-field'

import iciHint from './components/ici-hint.vue'

import IciTour from './components/ici-tour'

import imgViewDirective from './assets/imgView-directive'
import tourDirective from './assets/tour-directive'


const components = {
  iciButton,
  iciMultipleField,
  iciRadioField,
  iciInput,
  iciInputGroup,
  iciHint,
  IciTour,
}



const install = function (Vue, options) {

  if (install.installed) return;
  Object.keys(components).forEach(function (val) {
    return Vue.component(val, components[val]);
  });

  // 注册一个全局自定义指令 `v-focus`
  Vue.directive('focus', {
    // 指令的定义
    update: function (el, binding) {
      if (binding.value && binding.value !== binding.oldValue) {
        setTimeout(function () {
          el.focus();
        }, 150)
      }
    },
    inserted: function (el, binding) {
      if (binding.value) {
        setTimeout(function () {
          el.focus();
        }, 150);
      }
    }
  })

  //图片预览
  imgViewDirective(Vue)



  tourDirective(Vue, options);
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
export default {install: install};

export {
  iciButton,
  iciMultipleField,
  iciRadioField,
  iciInput,
  iciInputGroup,

  iciHint,
  IciTour,
}

